import React, { useContext, useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Calendar from "examples/Calendar";

//User Data
import { UserContext } from "context";

// ENV Values
const apiUrl = process.env.REACT_APP_API_URL;

function Meeting() {
  const { user } = useContext(UserContext);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox mb={1.5}>
          <Calendar />
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Meeting;
